import { authProvider } from './authProvider'

// TODO: Move these to settings or retrieve from server
const baseUrl = '/api'
const apiScope = {
  scopes: ['api://16af2a44-dbad-4ec1-9295-1415aac34763/access_as_user'],
}

const get = async (url) => {
  const token = await authProvider.getAccessToken(apiScope)
  return fetch(`${baseUrl}${url}`, {
    method: 'GET',
    headers: {
      Authorization: 'Bearer ' + token.accessToken,
      'Content-Type': 'application/json',
    },
  })
}

const post = async (url, data) => {
  const token = await authProvider.getAccessToken(apiScope)
  return fetch(`${baseUrl}${url}`, {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      Authorization: 'Bearer ' + token.accessToken,
      'Content-Type': 'application/json',
    },
  })
}

const deleteCall = async (url) => {
  const token = await authProvider.getAccessToken(apiScope)
  return fetch(`${baseUrl}${url}`, {
    method: 'DELETE',
    headers: {
      Authorization: 'Bearer ' + token.accessToken,
      'Content-Type': 'application/json',
    },
  })
}

export default { get, post, deleteCall }
